<template>
  <transition name="menuTrans">
    <div class="menu-container grid-x align-right" v-if="isMenuOpen">
      <transition name="fade" mode="out-in">
        <div
          v-if="currentImage !== null"
          :key="currentImage"
          class="background"
          :style="{'background-image' : 'url(' + images[currentImage] + ')'}"
        ></div>
      </transition>
      <div class="background default" @click="closeMenu()" data-hover="link" data-negative="true"></div>
      <div class="right cell">
        <div class="wrapper grid-y align-justify">
          <div class="top cell">
            <div class="inner grid-x grid-margin-x">
              <div
                @mouseover="currentImage = 0"
                @mouseleave="currentImage = null"
                v-if="isMenuOpen"
                class="element cell large-4 large-offset-0"
              >
                <p class="h6 title">
                  <!-- <span>Dinamo</span> -->
                  <router-link :to="{name: 'home'}">Dinamo</router-link>
                </p>
                <p class="desc">{{$t('nav.chi.desc')}}</p>
                <div class="nav-link">
                  <router-link
                    :to="{name: 'page', params: {page: $t('nav.chi.children.vision.slug')}}"
                  >{{$t('nav.chi.children.vision.title')}}</router-link>
                  <!-- <router-link
                    :to="{name: 'page', params: {page: $t('nav.chi.children.competenze.slug')}}"
                  >{{$t('nav.chi.children.competenze.title')}}</router-link> -->
                </div>
                <div class="nav-link">
                  <router-link
                    :to="{name: 'page', params: {page: $t('nav.chi.children.metodo.slug')}}"
                  >{{$t('nav.chi.children.metodo.title')}}</router-link>
                </div>
                <div class="nav-link">
                  <router-link
                    :to="{name: 'page', params: {page: $t('nav.chi.children.persone.slug')}}"
                  >{{$t('nav.chi.children.persone.title')}}</router-link>
                </div>
              </div>
              <div
                @mouseover="currentImage = 1"
                @mouseleave="currentImage = null"
                v-if="isMenuOpen"
                class="element cell large-4 large-offset-0"
              >
                <!-- <p class="h6 title">
                  <span>{{$t('nav.come.title')}}</span>
                </p> -->
                <router-link class="h6 title"
                    :to="{name: 'page', params: {page: $t('nav.chi.children.competenze.slug')}}"
                  >{{$t('nav.chi.children.competenze.title')}}</router-link>
                <p class="desc">{{$t('nav.come.desc')}}</p>
                <div class="nav-link">
                  <router-link
                    :to="{name: 'page', params: {page: $t('nav.come.children.marketing.slug')}}"
                  >{{$t('nav.come.children.marketing.title')}}</router-link>
                </div>
                <div class="nav-link">
                  <router-link
                    :to="{name: 'page', params: {page: $t('nav.come.children.design.slug')}}"
                  >{{$t('nav.come.children.design.title')}}</router-link>
                </div>
                <div class="nav-link">
                  <router-link
                    :to="{name: 'page', params: {page: $t('nav.come.children.building.slug')}}"
                  >Automation & IoT</router-link>
                </div>
              </div>
              <div
                @mouseover="currentImage = 2"
                @mouseleave="currentImage = null"
                v-if="isMenuOpen"
                class="element cell large-4 large-offset-0"
              >
                <p class="h6 title">
                  <!-- <span>{{$t('nav.cosa.title')}}</span> -->
                  <router-link
                    :to="'/' + $i18n.locale + '/'+ $t('nav.cosa.slug')"
                  >{{$t('nav.cosa.title')}}</router-link>
                </p>
                <p class="desc">{{$t('nav.cosa.desc')}}</p>
                <div class="nav-link">
                  <router-link
                    :to="{name: 'cosa', params: '/' + $i18n.locale + '/'+ $t('nav.cosa.slug'), query: {filter: 'client'}}"
                  >{{$t('nav.cosa.children.portfolio.title')}}</router-link>
                </div>
                <div class="nav-link">
                  <router-link
                    :to="{name: 'cosa', params:'/' + $i18n.locale + '/'+ $t('nav.cosa.slug'), query: {filter: 'show-case'}}"
                  >{{$t('nav.cosa.children.casi.title')}}</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom cell">
            <div class="grid grid-x">
              <div class="inner cell small-12">
                <p class="fix-mobile-font">
                  <span class="dinamo"></span>
                  <template v-if="currentlyOpen">{{$t('nav.contatti.aperto')}}</template>
                  <template v-else>{{$t('nav.contatti.chiuso')}}</template>
                  <Clock :hRotate="hRotate" :mRotate="mRotate" class="not-mobile" />
                </p>
              </div>
            </div>
            <div class="grid grid-x">
              <div class="inner small-12">
                <p class="fix-mobile-font">
                  {{$t('nav.contatti.mail')}}
                  <a
                    data-hover="link"
                    href="mailto:info@dinamodigitale.it"
                  >e-mail</a>
                  {{$t('nav.contatti.whatsapp')}}
                  <a
                    data-hover="link"
                    target="_blank"
                    href="https://wa.me/390577533055"
                  >WhatsApp</a>.
                  <br />
                  {{$t('nav.contatti.telefono')}}
                  <a
                    data-hover="link"
                    href="tel://+390577533055"
                  >{{$t('nav.contatti.telefonare')}}</a>
                  {{$t('nav.contatti.o')}}
                  <a
                    data-hover="link"
                    target="_blank"
                    href="https://www.google.com/maps/search/Zona+Industriale+Belvedere,+83+ingr.+2+-+53034+Colle+di+Val+d'Elsa+(Siena)/@43.4107005,11.1564058,16z/data=!3m1!4b1"
                  >{{$t('nav.contatti.venire')}}</a>
                  {{$t('nav.contatti.persona')}}
                </p>
              </div>
            </div>
            <div class="grid vertical grid-x">
              <div class="inner half cell small-12 large-6">
                <p>
                  <a href="https://www.facebook.com/DinamoComunicazione/" target="_blank">
                    <Icon data-hover="link" icon="facebook" />
                  </a>
                  <a href="https://twitter.com/dinamodigitale" target="_blank">
                    <Icon data-hover="link" icon="twitter" />
                  </a>
                  <a href="https://www.instagram.com/dinamodigitale/" target="_blank">
                    <Icon data-hover="link" icon="instagram" />
                  </a>
                  <a href="https://www.linkedin.com/company/dinamodigitale" target="_blank">
                    <Icon data-hover="link" icon="linkedin" />
                  </a>
                </p>
              </div>
              <div class="inner cell small-12 half large-6">
                <LanguageSwitch v-if="false" />
              </div>
              <div class="cell inner small-12 contacts">
                <p>
                  Zona Industriale Belvedere, 83 - 53034 Colle di Val d'Elsa (SI) |
                  <a
                    data-hover="link"
                    href="mailto:info@dinamodigitale.it"
                  >info@dinamodigitale.it</a> |
                  <nobr>
                    <a data-hover="link" href="tel://+390577533055">+39 0577 533 055</a>
                  </nobr> |
                  <nobr>P. IVA 01324730520</nobr>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import Clock from "@components/global/Clock";
import LanguageSwitch from "@components/global/LanguageSwitch";

import chi from "@assets/img/chi.jpg";
import come from "@assets/img/come.jpg";
import cosa from "@assets/img/cosa.jpg";

export default {
  components: {
    Clock,
    LanguageSwitch
  },
  props: {
    isMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentImage: null,
      currentlyOpen: true,
      hRotate: 0,
      mRotate: 0,
      images: [chi, come, cosa]
    };
  },
  mounted() {
    setInterval(() => {
      let today = new Date();
      let h = today.getHours();
      let m = today.getMinutes();
      let d = today.getDay();
      this.hRotate = (h * 360) / 12;
      this.mRotate = (m * 360) / 60;
      if (d >= 1 && d <= 5) {
        if (h >= 18 || h < 9) {
          this.currentlyOpen = false;
        } else {
          if (!this.currentlyOpen) {
            this.currentlyOpen = true;
          }
        }
      } else {
        this.currentlyOpen = false;
      }
    }, 500);
  },
  methods: {
    setImage(index) {
      this.currentImage = this.images[index];
    },
    closeMenu() {
      this.$store.commit("changeMenuStatus", false);
    },
    changeImage(image) {
      console.log(image);
    },
    hover() {
      alert("yeye");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.contacts {
  p {
    font-size: 0.8rem;
    margin-bottom: 0;
  }
}
.fix-mobile-font {
  @include breakpoint(small only) {
    font-size: 1rem;
  }
}
.nav-link {
  font-weight: 700;
  margin-top: 32px;
  @include breakpoint(small only) {
    margin-top: 16px;
  }
  & + .nav-link {
    margin-top: 16px;
    @include breakpoint(small only) {
      margin-top: 8px;
    }
  }
  a {
    text-decoration: underline;
    &:hover {
      text-decoration: unset;
    }
    &.router-link-exact-active {
      text-decoration: none;
      opacity: 0.4;
      pointer-events: none;
    }
  }
}

.menu-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  .background {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($secondary-color, 0.9);
    background-size: cover;
    -webkit-background-size: auto 100%;
    background-position: left center;
    @include breakpoint(medium down) {
      display: none;
    }
    &:not(.default) {
      z-index: 1;
    }
    &:after {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-image: url("../../assets/img/video_pattern_lighter.png"),
        linear-gradient(rgba(27, 65, 80, 0.7), rgba(27, 65, 80, 0.7));
      background-position: 50% 50% 0 0;
      background-size: 18px auto;
      z-index: 1;
    }
  }
  .right {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 2;
    padding: 26.5vh 96px calc(26.5vh / 4) 128px;
    background: $white;
    width: 1010px;
    @include breakpoint(1359px down) {
      width: 800px;
    }
    @include breakpoint(medium down) {
      width: 100%;
    }
    @include breakpoint(1599px down) {
      padding: 26.5vh 64px calc(26.5vh / 4) 64px;
    }
    @media (max-height: 810px) {
      padding-top: 64px;
    }
    @include breakpoint(medium down) {
      padding: 64px 32px 32px 32px;
    }
    .wrapper {
      min-height: 100%;
      .top {
        width: 100%;
        .inner {
          @include breakpoint(large up) {
            &:hover {
              .element:not(:hover) {
                opacity: 0.4;
              }
            }
          }
          .element {
            will-change: opacity;
            transition: opacity 0.35s;
            cursor: pointer;
            position: relative;
            @include breakpoint(medium down) {
              margin-top: 64px;
              padding-left: 32px;
              &:first-of-type {
                margin-top: 32px;
              }
            }
            @include breakpoint(small only) {
              margin-top: 32px;
              &:first-of-type {
                margin-top: 16px;
              }
            }
            .title {
              font-weight: $global-weight-bold;
              margin-bottom: 0;
              // span {
              //   text-decoration: underline;
              // }
            }
            .desc {
              margin-bottom: 0;
              margin-top: 64px;
              min-height: 92px;
              @include breakpoint(medium down) {
                display: none;
              }
            }
            &:hover {
              .title span {
                text-decoration: none;
              }
            }
            &.router-link-exact-active {
              pointer-events: none;
              p {
                opacity: 0.3;
                &.title span {
                  text-decoration: none;
                }
              }
            }
          }
        }
      }
      .bottom {
        width: 100%;
        .grid {
          position: relative;
          margin-top: 64px;
          // &:first-of-type{
          //   margin-top: 0;
          // }
          @include breakpoint(medium down) {
            margin-top: 32px;
            &:first-of-type {
              margin-top: 64px;
            }
          }
          &.vertical {
            align-items: center;
          }
          .inner {
            @include breakpoint(medium down) {
              padding-left: 32px;
            }
            .social-br {
              @include breakpoint(medium up) {
                display: none;
              }
            }
            &:not(.half) {
              p {
                margin-bottom: 0;
                a {
                  font-weight: $global-weight-bold;
                  text-decoration: underline;
                  &:hover {
                    text-decoration: none;
                  }
                }
                /deep/ .clock-wrapper {
                  margin-left: 32px;
                  margin-bottom: 6px;
                }
                .dinamo {
                  width: 76px;
                  height: 15px;
                  background-image: url("../../assets/img/dinamo-word.svg");
                  display: inline-block;
                  background-size: auto 100%;
                  background-repeat: no-repeat;
                  background-position: left center;
                  vertical-align: middle;
                  position: relative;
                  bottom: 2px;
                  @include breakpoint(small only) {
                    width: 69px;
                    height: 13px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@keyframes menuOpacityTrans {
  0% {
    opacity: 0;
  }
  50%,
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes menuOpacityTrans {
  0% {
    opacity: 0;
  }
  50%,
  100% {
    opacity: 1;
  }
}
@keyframes menuWidthTrans {
  0% {
    width: 0;
  }
  50%,
  100% {
    width: 1010px;
  }
}
@-webkit-keyframes menuWidthTrans {
  0% {
    width: 0;
  }
  50%,
  100% {
    width: 1010px;
  }
}
@keyframes menuWidthTransAlt {
  0% {
    width: 0;
  }
  50%,
  100% {
    width: 800px;
  }
}
@-webkit-keyframes menuWidthTransAlt {
  0% {
    width: 0%;
  }
  50%,
  100% {
    width: 800px;
  }
}
@keyframes menuWidthTransMobile {
  0% {
    width: 0%;
  }
  50%,
  100% {
    width: 100%;
  }
}
@-webkit-keyframes menuWidthTransMobile {
  0% {
    width: 0%;
  }
  50%,
  100% {
    width: 100%;
  }
}
@keyframes menuVoicesTransFirst {
  0%,
  50% {
    opacity: 0;
    bottom: -64px;
  }
  80%,
  100% {
    opacity: 1;
    bottom: 0;
  }
}
@-webkit-keyframes menuVoicesTransFirst {
  0%,
  50% {
    opacity: 0;
    bottom: -64px;
  }
  80%,
  100% {
    opacity: 1;
    bottom: 0;
  }
}
@keyframes menuVoicesTransSecond {
  0%,
  60% {
    opacity: 0;
    bottom: -64px;
  }
  90%,
  100% {
    opacity: 1;
    bottom: 0;
  }
}
@-webkit-keyframes menuVoicesTransSecond {
  0%,
  60% {
    opacity: 0;
    bottom: -64px;
  }
  90%,
  100% {
    opacity: 1;
    bottom: 0;
  }
}
@keyframes menuVoicesTransThird {
  0%,
  70% {
    opacity: 0;
    bottom: -64px;
  }
  100% {
    opacity: 1;
    bottom: 0;
  }
}
@-webkit-keyframes menuVoicesTransThird {
  0%,
  70% {
    opacity: 0;
    bottom: -64px;
  }
  100% {
    opacity: 1;
    bottom: 0;
  }
}
@keyframes menuVoicesTransThird {
  0%,
  70% {
    opacity: 0;
    bottom: -64px;
  }
  100% {
    opacity: 1;
    bottom: 0;
  }
}
@-webkit-keyframes menuVoicesTransThird {
  0%,
  70% {
    opacity: 0;
    bottom: -64px;
  }
  100% {
    opacity: 1;
    bottom: 0;
  }
}
.menuTrans-enter-active {
  @include transition-duration(0.8s);
  .background {
    animation: menuOpacityTrans 0.8s;
    -webkit-animation: menuOpacityTrans 0.8s;
    animation-timing-function: ease-in-out;
    -webkit-animation-timing-function: ease-in-out;
  }
  .right {
    overflow-y: hidden;
    @include breakpoint(1360px up) {
      animation: menuWidthTrans 0.8s;
      -webkit-animation: menuWidthTrans 0.8s;
    }
    @include breakpoint(1359px down) {
      animation: menuWidthTransAlt 0.8s;
      -webkit-animation: menuWidthTransAlt 0.8s;
    }
    @include breakpoint(medium down) {
      animation: menuWidthTransMobile 0.8s;
      -webkit-animation: menuWidthTransMobile 0.8s;
    }
    animation-timing-function: ease-in-out;
    -webkit-animation-timing-function: ease-in-out;
  }
  .right {
    .wrapper {
      .top {
        .inner {
          .element {
            animation-timing-function: ease-in-out;
            -webkit-animation-timing-function: ease-in-out;
            &:nth-child(1) {
              animation: menuVoicesTransFirst 0.8s;
              -webkit-animation: menuVoicesTransFirst 0.8s;
            }
            &:nth-child(2) {
              animation: menuVoicesTransSecond 0.8s;
              -webkit-animation: menuVoicesTransSecond 0.8s;
            }
            &:nth-child(3) {
              animation: menuVoicesTransThird 0.8s;
              -webkit-animation: menuVoicesTransThird 0.8s;
            }
          }
        }
      }
      .bottom {
        .grid {
          animation-timing-function: ease-in-out;
          -webkit-animation-timing-function: ease-in-out;
          &:nth-child(1) {
            animation: menuVoicesTransFirst 0.8s;
            -webkit-animation: menuVoicesTransFirst 0.8s;
          }
          &:nth-child(2) {
            animation: menuVoicesTransSecond 0.8s;
            -webkit-animation: menuVoicesTransSecond 0.8s;
          }
          &:nth-child(3) {
            animation: menuVoicesTransThird 0.8s;
            -webkit-animation: menuVoicesTransThird 0.8s;
          }
        }
      }
    }
  }
}
.menuTrans-leave-active {
  @include transition-duration(0.7s);
  .background {
    animation: menuOpacityTrans 0.8s reverse;
    -webkit-animation: menuOpacityTrans 0.8s reverse;
    animation-timing-function: ease-in-out;
    -webkit-animation-timing-function: ease-in-out;
  }
  .right {
    overflow-y: hidden;
    @include breakpoint(xlarge up) {
      animation: menuWidthTrans 0.8s reverse;
      -webkit-animation: menuWidthTrans 0.8s reverse;
    }
    @include breakpoint(large only) {
      animation: menuWidthTransAlt 0.8s reverse;
      -webkit-animation: menuWidthTransAlt 0.8s reverse;
    }
    @include breakpoint(medium down) {
      animation: menuWidthTransMobile 0.8s reverse;
      -webkit-animation: menuWidthTransMobile 0.8s reverse;
    }
    animation-timing-function: ease-in-out;
    -webkit-animation-timing-function: ease-in-out;
  }
  .right {
    .wrapper {
      .top {
        .inner {
          .element {
            animation-timing-function: ease-in-out;
            -webkit-animation-timing-function: ease-in-out;
            &:nth-child(1) {
              animation: menuVoicesTransFirst 0.8s reverse;
              -webkit-animation: menuVoicesTransFirst 0.8s reverse;
            }
            &:nth-child(2) {
              animation: menuVoicesTransSecond 0.8s reverse;
              -webkit-animation: menuVoicesTransSecond 0.8s reverse;
            }
            &:nth-child(3) {
              animation: menuVoicesTransThird 0.8s reverse;
              -webkit-animation: menuVoicesTransThird 0.8s reverse;
            }
          }
        }
      }
      .bottom {
        .grid {
          animation-timing-function: ease-in-out;
          -webkit-animation-timing-function: ease-in-out;
          &:nth-child(1) {
            animation: menuVoicesTransFirst 0.8s reverse;
            -webkit-animation: menuVoicesTransFirst 0.8s reverse;
          }
          &:nth-child(2) {
            animation: menuVoicesTransSecond 0.8s reverse;
            -webkit-animation: menuVoicesTransSecond 0.8s reverse;
          }
          &:nth-child(3) {
            animation: menuVoicesTransThird 0.8s reverse;
            -webkit-animation: menuVoicesTransThird 0.8s reverse;
          }
        }
      }
    }
  }
}

.fade-enter {
  opacity: 0;
}

.fade-enter-to {
  opacity: 1;
}

.fade-leave {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}
</style>
